import { useAuth, RedirectToSignIn } from '@clerk/react';
import { Outlet } from 'react-router';

export function ProtectedRoute() {
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded) return null;
  if (!isSignedIn) return <RedirectToSignIn />;

  return <Outlet />;
}
